import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ButtonVehiclesWithoutGeoZoneReportModal from '../button-vehicles-without-geo-zone-report';

const ReportVehiclesWithoutGeoZoneEventRow = ({ item, t }) => {
  const warningIconStyle = {
    backgroundImage: "url('/assets/warning-icon.png')",
    backgroundSize: '16px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px center',
    paddingLeft: '26px',
    margin: '3px 6px 0px 0px',
    fontSize: '14px',
    textTransform: 'none',
    fontFamily: 'LatoLatin',
  };

  return (
    <tr>
      <td>
        <Link
          to={{
            pathname: `/orders/${item?.id}/view`,
          }}
          className="btn table-button"
        >
          {item?.number}
        </Link>
      </td>
      <td>
        {item?.vehicle?.number_plate}
        <span>&nbsp;</span>
        {
          item?.vehicle?.navisat_external_id ? ''
            : (
              <>
                <span style={warningIconStyle} id="UncontrolledTooltipIvmsVehicle" />
                <UncontrolledTooltip placement="right" target="UncontrolledTooltipIvmsVehicle">
                  {t('vehicle.no_ivms_for_vehicle')}
                </UncontrolledTooltip>
              </>
            )
        }
      </td>
      <td>{item?.trip?.client_address?.client?.name}</td>
      <td>
        {item?.trip?.client_address?.address}
        <span>&nbsp;</span>
        {
          item?.trip?.client_address?.navisat_geozone_name?.trim() ? ''
            : (
              <>
                <span style={warningIconStyle} id="UncontrolledTooltipIvmsAddress" />
                <UncontrolledTooltip placement="right" target="UncontrolledTooltipIvmsAddress">
                  {t('clients.no_ivms_for_client_address')}
                </UncontrolledTooltip>
              </>
            )
        }
      </td>
      <td><ButtonVehiclesWithoutGeoZoneReportModal order={item} /></td>
    </tr>
  );
};

ReportVehiclesWithoutGeoZoneEventRow.propTypes = {
  item: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation(),
)(ReportVehiclesWithoutGeoZoneEventRow);
